/**
 * OS1 web — canonical config shared across components.
 *
 * Build-time `VITE_PUBLIC_ORIGIN` and `VITE_MOBILE_ORIGIN` are injected by
 * `apps/web/Dockerfile` (see `docs/deployment.md`). Defaults match the
 * production deployment so local dev still gets canonical URLs that point
 * somewhere real.
 *
 * Keep this file framework-free so it can be imported from anywhere.
 */

export const PRODUCTION_ORIGIN: string =
  (import.meta.env.VITE_PUBLIC_ORIGIN as string | undefined) ?? "https://os1.agnos.com.br";

export const MOBILE_ORIGIN: string =
  (import.meta.env.VITE_MOBILE_ORIGIN as string | undefined) ?? "https://os1.agnos.com.br";

export const COMMIT_SHA: string =
  (import.meta.env.VITE_COMMIT_SHA as string | undefined) ?? "dev";

/**
 * Returns the canonical absolute URL for a path on the OS1 web site.
 * Used for install link generation, share URLs, and Open Graph tags.
 */
export const canonicalUrl = (path: string): string => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${PRODUCTION_ORIGIN}${normalized}`;
};

/**
 * Mobile-origin variant — for install links that should send the visitor
 * to the mobile-tuned `/m/` surface on the production host.
 */
export const mobileUrl = (path: string): string => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${MOBILE_ORIGIN}${normalized}`;
};
